module.exports = __webpack_public_path__ + "static/905-8d9eb1210d4379f7975cb14cce55e1e4.png";